import { useContext } from "react";
import { Context } from "..";
import { observer } from "mobx-react-lite";
import LicenseAPI from "../API/LicenseAPI";

const Rates = () => {
    const { store } = useContext(Context);

    const buyLicense = async () => {
        try {
            const response = await LicenseAPI.getLink();
            if (!response.data) throw response;
            window.location.replace(response.data);
        } catch (err) {
            console.log("[x] Ошибка получения ссылки на оплату лицензии:", err);
        }
    }
    const formatNumber = (num) => {
        if (!num) return 0;
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    return (
        <div className="setupBigContent ratesContent">
            <div className="titleLine">
                <div className="title">Всё, что нужно для<br />точных расчетов</div>
                <div className="subTitle">Выбирайте тариф с нужными возможностями — <br />от разовых расчетов до командной работы <br />с брендированными отчетами</div>
            </div>
            {store.userInfo && store.userInfo.license && <ul className="rateList">
                <li className={!store.userInfo.isLicensed ? "active" : ""}>
                    <div className="content">
                        <div className="rate">
                            <div className="title">Демо</div>
                            <div className="description">Демо режим без возможности редактирования компонентов</div>
                        </div>
                        <div className="value">
                        <div className="price">
                                <div className="value">0</div>
                                <div className="prefix">₽/мес</div>
                            </div>
                            {!store.userInfo.isLicensed && <div className="manage">Тариф сейчас активен</div>}
                        </div>
                    </div>
                </li>
                <li className={store.userInfo.isLicensed ? "active" : ""}>
                    <div className="content">
                        <div className="rate">
                            <div className="title">Стандарт</div>
                            <div className="description">Режим полного доступа к калькулятору расчета стоимости бухгалтерских услуг</div>
                        </div>
                        <div className="value">
                            <div className={store.userInfo.license.cost != store.userInfo.license.costWithDiscount ? "price discount" : "price"}>
                                <div className="value">{formatNumber(store.userInfo.license.cost)}</div>
                                { store.userInfo.license.cost != store.userInfo.license.costWithDiscount && <div className="valueDiscount">{formatNumber(store.userInfo.license.costWithDiscount)}</div>}
                                <div className="prefix">₽/мес</div>
                            </div>
                            <div className="manage">
                                {store.userInfo.isLicensed ? "Тариф сейчас активен":<button className="activeButton" onClick={() => buyLicense()}>Выбрать</button>}
                            </div>
                        </div>
                    </div>
                </li>
            </ul>}
        </div>
    );
}

export default observer(Rates);
